<template>
  <Loading v-if="componentLoading" :style="style" />
  <Chart v-else class="pft-word-cloud" :option="chartConfig" :style="style"></Chart>
</template>

<script setup lang="ts">
import Chart from "@p-v/packages/Charts/BaseChart/index.vue"
import { ref } from "vue"
import { cloneDeep, defaultsDeep } from "lodash-es"
import defaultOption from "./config"
import Loading from "@p-v/packages/Loading.vue"
import { EChartsOption } from "echarts"

interface WordCloudProps {
  data?: {
    name: string
    value: number
  }[]
  style?: any
  option?: any
}

const props = defineProps<WordCloudProps>()

const componentLoading = ref(true)
const chartConfig = ref<any>(defaultsDeep(defaultOption, props.option))

if (props.data && Array.isArray(props.data)) {
  chartConfig.value.series[0].data = props.data
  componentLoading.value = false
}

const loading = () => {
  componentLoading.value = true
}
const setData = (data: WordCloudProps) => {
  if (!data || !data.data) {
    return
  }
  componentLoading.value = false
  const invisible = data.data.length > 0
  const newConfig = cloneDeep(defaultOption)
  const finalConfig = defaultsDeep(newConfig, props.option, data.option, {
    series: [
      {
        data: data.data,
      },
    ],
    graphic: [
      {
        invisible,
      },
    ],
  })
  chartConfig.value = finalConfig
}

defineExpose({ setData, loading })
</script>

<style lang="scss" scoped></style>
